import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {DatePipe, NgIf} from "@angular/common";
import {Router} from "@angular/router";

@Component({
  selector: 'app-hc-component-expired',
  standalone: true,
  imports: [
    TranslateModule,
    NgIf,
    DatePipe
  ],
  templateUrl: './hc-component-expired.component.html',
  styleUrl: './hc-component-expired.component.scss'
})
export class HcComponentExpiredComponent implements OnInit{
  public locale = 'en';
  @Input() public date;
  @Output() forceNewHC = new EventEmitter<void>();

  constructor(
    private _translateService:TranslateService,
    private router:Router,
  ) {
  }

  ngOnInit() {
    this.locale = this._translateService.currentLang;
  }

  restartProcess():void {
    this.forceNewHC.emit();
  }
}
